import _defineProperty from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/esnext.global-this.js";
import "./index.css";
import { jsx as e, jsxs as s } from "react/jsx-runtime";
import t, { forwardRef as c } from "react";
import { Container as r } from "@design-system/container";
import { ExtendableImage as i } from "@design-system/extendable-image";
import { Section as o } from "@design-system/section";
import a from "classnames";
import { CtaBlock as l } from "@design-system/cta-block";
import { HeadingBlock as n } from "@design-system/heading-block";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function d(e, s) {
  var t = {};

  for (var c in e) {
    Object.prototype.hasOwnProperty.call(e, c) && s.indexOf(c) < 0 && (t[c] = e[c]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (c = Object.getOwnPropertySymbols(e); r < c.length; r++) {
      s.indexOf(c[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, c[r]) && (t[c[r]] = e[c[r]]);
    }
  }

  return t;
}

var p = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function m(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

var g = {},
    u = {};
!function (e) {
  var s = p && p.__assign || function () {
    return s = Object.assign || function (e) {
      for (var s, t = 1, c = arguments.length; t < c; t++) {
        for (var r in s = arguments[t]) {
          Object.prototype.hasOwnProperty.call(s, r) && (e[r] = s[r]);
        }
      }

      return e;
    }, s.apply(this, arguments);
  },
      c = p && p.__rest || function (e, s) {
    var t = {};

    for (var c in e) {
      Object.prototype.hasOwnProperty.call(e, c) && s.indexOf(c) < 0 && (t[c] = e[c]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var r = 0;

      for (c = Object.getOwnPropertySymbols(e); r < c.length; r++) {
        s.indexOf(c[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, c[r]) && (t[c[r]] = e[c[r]]);
      }
    }

    return t;
  },
      r = p && p.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.IcomoonReact = e.iconList = void 0;
  var i = r(t);
  e.iconList = function (e) {
    var s = [];
    return e.icons.forEach(function (e) {
      s.push(e.properties.name.split(", ")[0]);
    }), s;
  }, e.IcomoonReact = function (e) {
    var t = e.color,
        r = e.size,
        o = void 0 === r ? "100%" : r,
        a = e.icon,
        l = e.iconSet,
        n = e.className,
        d = void 0 === n ? "" : n,
        p = e.style,
        m = void 0 === p ? {} : p,
        g = c(e, ["color", "size", "icon", "iconSet", "className", "style"]);
    return function (e, t, c, r, o, a) {
      var l,
          n = t.icons.find(function (s) {
        return s.properties.name.split(", ").includes(e);
      });
      return n ? i.default.createElement("svg", s({
        className: o,
        style: c.svg,
        width: r,
        height: r,
        viewBox: "0 0 " + (n.icon.width || "1024") + " 1024",
        xmlns: "http://www.w3.org/2000/svg"
      }, a), n.icon.paths.map((l = n.icon, function (e, t) {
        var r = l.attrs && l.attrs[t] || {};
        return i.default.createElement("path", s({
          style: c.path,
          key: t,
          d: e
        }, r));
      }))) : (console.warn("icon " + e + " does not exist."), null);
    }(a, l, {
      svg: s({
        display: "inline-block",
        verticalAlign: "middle"
      }, m),
      path: {
        fill: t
      }
    }, o, d, g);
  }, e.IcomoonReact.displayName = "IcomoonReact", e.default = e.IcomoonReact;
}(u), function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var s = u,
      t = u;
  Object.defineProperty(e, "iconList", {
    enumerable: !0,
    get: function get() {
      return t.iconList;
    }
  }), e.default = s.IcomoonReact;
}(g);
var h = m(g),
    v = {
  IcoMoonType: "selection",
  icons: [{
    icon: {
      paths: ["M934.411 439.542h-78.497c5.363-18.972 8.092-38.753 8.097-58.652 0.030-38.228-10.075-75.607-29.035-107.406-18.96-31.798-45.922-56.587-77.474-71.228-31.553-14.642-66.278-18.476-99.779-11.021-33.502 7.455-64.273 25.867-88.421 52.905l-57.291 64.137-57.277-64.23c-27.374-30.619-63.147-50.054-101.575-55.185s-77.282 4.338-110.325 26.889c-33.041 22.551-58.354 56.875-71.872 97.459-13.52 40.586-14.46 85.077-2.672 126.333h-78.679v31.516h90.239c8.112 17.264 18.513 33.054 30.849 46.834l291.456 326.746c1.307 1.465 2.86 2.628 4.57 3.42 1.71 0.794 3.541 1.202 5.392 1.202s3.682-0.408 5.392-1.202c1.71-0.792 3.263-1.956 4.57-3.42l291.456-326.746c12.27-13.8 22.612-29.588 30.68-46.834h90.197v-31.516zM230.552 266.344c13.397-15.046 29.316-26.982 46.844-35.129 17.529-8.145 36.321-12.338 55.299-12.338 18.98 0 37.771 4.193 55.3 12.338 17.527 8.146 33.446 20.083 46.844 35.129l67.231 75.371c2.691 2.852 6.256 4.442 9.963 4.442 3.705 0 7.27-1.59 9.961-4.442l67.218-75.355c20.217-22.62 45.976-38.019 74.017-44.248s57.101-3.011 83.506 9.252c26.405 12.261 48.967 33.013 64.829 59.63 15.863 26.617 24.316 57.903 24.287 89.897-0.026 20.063-3.368 39.949-9.856 58.652h-146.615c-2.49 0-4.937 0.74-7.088 2.143s-3.934 3.42-5.161 5.845l-19.627 38.814-19.628-38.814c-1.118-2.207-2.695-4.082-4.598-5.461s-4.075-2.224-6.333-2.463c-2.257-0.238-4.533 0.138-6.633 1.095-2.099 0.957-3.962 2.468-5.429 4.403l-80.199 105.675-55.292-164.075c-0.939-2.81-2.573-5.262-4.713-7.068s-4.696-2.891-7.369-3.127c-2.667-0.267-5.345 0.334-7.714 1.732-2.368 1.398-4.324 3.533-5.633 6.147l-55.194 109.157-50.688-50.175c-2.574-2.54-5.888-3.941-9.321-3.94h-130.732c-10.095-29.284-12.395-61.214-6.623-91.93 5.773-30.717 19.369-58.904 39.148-81.158zM793.513 495.626l-281.502 315.558-281.459-315.558c-6.684-7.516-12.698-15.744-17.953-24.567h110.74l59.755 59.093c1.572 1.552 3.433 2.692 5.449 3.337 2.014 0.646 4.133 0.779 6.199 0.391s4.031-1.289 5.747-2.634c1.717-1.345 3.143-3.102 4.176-5.144l48.957-96.786 53.137 157.582c0.863 2.573 2.313 4.848 4.204 6.601s4.159 2.92 6.578 3.389c2.421 0.468 4.907 0.22 7.215-0.72 2.307-0.94 4.355-2.539 5.939-4.638l82.594-108.857 21.936 43.398c1.333 2.276 3.152 4.144 5.292 5.439 2.139 1.293 4.533 1.97 6.965 1.97 2.431 0 4.824-0.677 6.965-1.97 2.139-1.294 3.958-3.163 5.292-5.439l27.85-55.012h123.904c-5.272 8.818-11.294 17.045-17.98 24.567z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["heart"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 59,
      id: 29,
      name: "heart",
      prevSize: 32,
      code: 59673
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 0
  }, {
    icon: {
      paths: ["M894.898 386.807l-51.2-119.809c-0.799-1.867-2.001-3.519-3.513-4.824-1.512-1.307-3.292-2.234-5.204-2.709l-320-79.873c-1.96-0.492-4.005-0.492-5.965 0l-320 79.873c-1.911 0.475-3.692 1.402-5.204 2.709-1.512 1.306-2.714 2.957-3.513 4.824l-51.2 119.809c-0.761 1.785-1.136 3.722-1.097 5.675 0.039 1.951 0.49 3.871 1.322 5.622 0.832 1.749 2.024 3.288 3.491 4.507 1.468 1.217 3.175 2.085 5.001 2.54l41.382 10.33v336.156c0.001 2.991 0.971 5.892 2.752 8.24 1.781 2.347 4.27 4.002 7.066 4.699l320 79.872c1.96 0.498 4.006 0.498 5.965 0l320-79.872c2.796-0.697 5.285-2.352 7.067-4.699 1.781-2.348 2.749-5.249 2.751-8.24v-336.156l41.382-10.33c1.826-0.455 3.533-1.323 5.001-2.54 1.468-1.219 2.66-2.758 3.492-4.507 0.832-1.751 1.283-3.671 1.323-5.622 0.038-1.953-0.336-3.89-1.098-5.675zM511.999 206.215l265.152 66.189-265.152 66.187-265.152-66.187 265.152-66.189zM199.371 287.925l294.707 73.563-40.627 95.061-294.733-73.549 40.653-95.076zM204.799 421.871l253.018 63.152c2.908 0.725 5.969 0.37 8.651-1.007 2.681-1.377 4.816-3.685 6.030-6.528l26.701-62.487v399.629l-294.4-73.496v-319.263zM819.199 741.134l-294.4 73.496v-399.629l26.701 62.487c1.006 2.354 2.647 4.355 4.723 5.759 2.076 1.402 4.5 2.15 6.976 2.149 1.006 0 2.007-0.125 2.982-0.373l253.018-63.152v319.263zM570.571 456.549l-40.653-95.061 294.682-73.563 40.678 95.076-294.707 73.549z", "M556.105 656.209c1.399 0.97 2.967 1.644 4.617 1.984s3.346 0.338 4.995-0.003c1.648-0.343 3.217-1.020 4.614-1.993s2.596-2.222 3.529-3.676l2.15-3.395v115.816c0 3.53 1.348 6.916 3.749 9.412 2.401 2.497 5.656 3.9 9.051 3.9s6.65-1.402 9.051-3.9c2.401-2.496 3.749-5.882 3.749-9.412v-115.816l2.15 3.355c1.884 2.937 4.813 4.976 8.142 5.668s6.787-0.020 9.611-1.98c2.825-1.96 4.786-5.006 5.45-8.468 0.666-3.463-0.020-7.058-1.904-9.997l-25.6-39.936c-1.239-1.721-2.846-3.119-4.695-4.082-1.847-0.963-3.887-1.465-5.955-1.465-2.066 0-4.106 0.502-5.955 1.465s-3.456 2.361-4.695 4.082l-25.6 39.936c-0.939 1.456-1.591 3.090-1.923 4.81-0.33 1.719-0.33 3.489 0 5.208 0.329 1.719 0.981 3.355 1.92 4.81 0.939 1.456 2.145 2.706 3.548 3.676z", "M663.451 639.243l2.15-3.395v102.504c0 3.53 1.348 6.916 3.749 9.412 2.401 2.497 5.656 3.9 9.051 3.9s6.65-1.402 9.051-3.9c2.401-2.496 3.749-5.882 3.749-9.412v-102.504l2.15 3.355c0.933 1.455 2.132 2.704 3.53 3.676 1.397 0.973 2.964 1.648 4.612 1.991 1.65 0.343 3.346 0.344 4.995 0.004 1.65-0.34 3.218-1.014 4.617-1.984 1.399-0.97 2.6-2.217 3.534-3.671 0.936-1.454 1.587-3.083 1.916-4.797 0.33-1.715 0.33-3.48 0.004-5.195-0.327-1.715-0.976-3.346-1.909-4.801l-25.6-39.936c-1.239-1.721-2.846-3.119-4.695-4.082-1.847-0.963-3.887-1.465-5.955-1.465s-4.106 0.502-5.955 1.465c-1.849 0.963-3.456 2.361-4.695 4.082l-25.6 39.936c-1.884 2.938-2.569 6.534-1.904 9.997 0.666 3.462 2.625 6.508 5.45 8.468s6.282 2.671 9.611 1.98c3.329-0.691 6.258-2.731 8.142-5.668v0.040z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["picto-box"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 32,
      id: 28,
      name: "box",
      prevSize: 32,
      code: 59669
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 1
  }, {
    icon: {
      paths: ["M702.663 510.969l122.012-122.012c11.53-11.574 18.004-27.244 18.004-43.58 0-16.337-6.474-32.007-18.004-43.58l-104.586-104.56c-11.57-11.537-27.241-18.014-43.58-18.014s-32.010 6.477-43.58 18.014l-122.012 122.012-122.012-122.012c-11.57-11.537-27.241-18.014-43.578-18.014-16.338 0-32.010 6.477-43.58 18.014l-104.549 104.573c-11.53 11.573-18.004 27.243-18.004 43.58 0 16.336 6.474 32.006 18.004 43.578l122.012 122.012-122.012 122.012c-11.53 11.574-18.004 27.244-18.004 43.58 0 16.337 6.474 32.007 18.004 43.58l104.573 104.573c11.568 11.538 27.24 18.020 43.58 18.020 16.338 0 32.011-6.481 43.58-18.020l122.012-122.012 122.012 122.012c11.568 11.538 27.24 18.020 43.58 18.020 16.338 0 32.010-6.481 43.578-18.020l104.573-104.573c11.53-11.573 18.004-27.243 18.004-43.58 0-16.336-6.474-32.006-18.004-43.58l-122.024-122.024zM650.358 214.663c6.946-6.915 16.35-10.798 26.152-10.798s19.206 3.883 26.153 10.798l104.573 104.573c6.921 6.945 10.807 16.348 10.807 26.153 0 9.803-3.887 19.207-10.807 26.152l-122.012 122.012-156.867-156.891 122.001-122zM667.809 510.969l-156.878 156.878-156.878-156.878 156.878-156.88 156.878 156.88zM214.625 371.541c-6.921-6.945-10.807-16.348-10.807-26.152 0-9.805 3.887-19.209 10.807-26.153l104.573-104.573c6.945-6.921 16.348-10.807 26.153-10.807 9.803 0 19.209 3.887 26.152 10.807l122.012 122.012-156.89 156.865-122.001-122zM371.503 807.275c-6.946 6.915-16.35 10.796-26.152 10.796s-19.206-3.881-26.153-10.796l-104.573-104.575c-6.921-6.943-10.807-16.348-10.807-26.152 0-9.805 3.887-19.209 10.807-26.153l122.012-122.012 156.867 156.891-122.001 122.001zM807.236 702.7l-104.573 104.575c-6.948 6.915-16.351 10.796-26.153 10.796s-19.206-3.881-26.152-10.796l-122.012-122.014 156.89-156.865 122.014 122.012c6.915 6.945 10.796 16.348 10.795 26.149-0.003 9.801-3.888 19.201-10.807 26.143z", "M412.325 523.315h24.649c3.268 0 6.403-1.298 8.715-3.61 2.311-2.311 3.61-5.446 3.61-8.714 0-3.27-1.298-6.404-3.61-8.715-2.313-2.311-5.447-3.61-8.715-3.61h-24.649c-3.27 0-6.404 1.298-8.715 3.61s-3.61 5.446-3.61 8.715c0 3.268 1.298 6.403 3.61 8.714s5.446 3.61 8.715 3.61z", "M498.603 523.315h24.649c3.268 0 6.403-1.298 8.715-3.61 2.311-2.311 3.61-5.446 3.61-8.714 0-3.27-1.298-6.404-3.61-8.715-2.313-2.311-5.447-3.61-8.715-3.61h-24.649c-3.27 0-6.404 1.298-8.715 3.61s-3.61 5.446-3.61 8.715c0 3.268 1.298 6.403 3.61 8.714s5.446 3.61 8.715 3.61z", "M572.555 510.992c0 3.268 1.298 6.403 3.61 8.714s5.447 3.61 8.715 3.61h24.649c3.268 0 6.404-1.298 8.715-3.61s3.61-5.446 3.61-8.714c0-3.27-1.298-6.404-3.61-8.715s-5.447-3.61-8.715-3.61h-24.649c-3.268 0-6.404 1.298-8.715 3.61s-3.61 5.446-3.61 8.715z", "M449.297 473.983h24.649c3.268 0 6.404-1.298 8.715-3.61s3.61-5.447 3.61-8.715c0-3.268-1.298-6.403-3.61-8.714-2.311-2.313-5.447-3.61-8.715-3.61h-24.649c-3.27 0-6.404 1.297-8.715 3.61-2.311 2.311-3.61 5.446-3.61 8.714s1.298 6.404 3.61 8.715c2.311 2.311 5.446 3.61 8.715 3.61z", "M498.603 424.704h24.649c3.268 0 6.403-1.298 8.715-3.61 2.311-2.311 3.61-5.446 3.61-8.714 0-3.27-1.298-6.404-3.61-8.715-2.313-2.311-5.447-3.61-8.715-3.61h-24.649c-3.27 0-6.404 1.298-8.715 3.61s-3.61 5.446-3.61 8.715c0 3.268 1.298 6.403 3.61 8.714s5.446 3.61 8.715 3.61z", "M547.908 473.983h24.649c3.268 0 6.403-1.298 8.715-3.61 2.311-2.311 3.61-5.447 3.61-8.715s-1.298-6.403-3.61-8.714c-2.313-2.313-5.447-3.61-8.715-3.61h-24.649c-3.27 0-6.404 1.297-8.715 3.61-2.311 2.311-3.61 5.446-3.61 8.714s1.298 6.404 3.61 8.715c2.311 2.311 5.446 3.61 8.715 3.61z", "M473.974 547.944h-24.65c-3.268 0-6.403 1.298-8.714 3.611-2.311 2.311-3.61 5.446-3.61 8.714s1.298 6.403 3.61 8.715c2.311 2.311 5.446 3.61 8.714 3.61h24.65c3.268 0 6.403-1.298 8.714-3.61 2.311-2.313 3.61-5.447 3.61-8.715s-1.298-6.403-3.61-8.714c-2.311-2.313-5.446-3.611-8.714-3.611z", "M572.557 547.944h-24.649c-3.27 0-6.404 1.298-8.715 3.611-2.311 2.311-3.61 5.446-3.61 8.714s1.298 6.403 3.61 8.715c2.311 2.311 5.446 3.61 8.715 3.61h24.649c3.268 0 6.403-1.298 8.715-3.61 2.311-2.313 3.61-5.447 3.61-8.715s-1.298-6.403-3.61-8.714c-2.313-2.313-5.447-3.611-8.715-3.611z", "M523.251 597.222h-24.649c-3.27 0-6.404 1.298-8.715 3.61s-3.61 5.446-3.61 8.715c0 3.268 1.298 6.403 3.61 8.714s5.446 3.61 8.715 3.61h24.649c3.268 0 6.403-1.298 8.715-3.61 2.311-2.311 3.61-5.446 3.61-8.714 0-3.27-1.298-6.404-3.61-8.715-2.313-2.311-5.447-3.61-8.715-3.61z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["picto-patch"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 30,
      id: 26,
      name: "patch",
      prevSize: 32,
      code: 59674
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 3
  }, {
    icon: {
      paths: ["M165.558 559.795c-3.169 0-6.208-1.259-8.448-3.499s-3.499-5.279-3.499-8.448v-71.68c0-3.169 1.259-6.207 3.499-8.447 2.24-2.241 5.279-3.5 8.448-3.5s6.207 1.259 8.448 3.5c2.24 2.24 3.499 5.278 3.499 8.447v71.68c0 3.169-1.259 6.208-3.499 8.448-2.241 2.24-5.279 3.499-8.448 3.499z", "M858.462 464.225c-3.169 0-6.207 1.259-8.447 3.499-2.241 2.24-3.5 5.279-3.5 8.448v23.893h-71.979c-1.697-38.010-11.686-75.189-29.269-108.929l62.41-36.032 11.947 20.692c1.596 2.722 4.203 4.702 7.252 5.508 3.051 0.806 6.295 0.373 9.027-1.205s4.73-4.171 5.557-7.215c0.826-3.045 0.415-6.293-1.143-9.035l-35.84-62.123c-0.779-1.37-1.822-2.571-3.066-3.537-1.246-0.966-2.67-1.675-4.19-2.088s-3.108-0.521-4.669-0.317c-1.563 0.203-3.069 0.713-4.434 1.5-1.364 0.788-2.559 1.838-3.516 3.089s-1.657 2.681-2.061 4.204c-0.402 1.523-0.499 3.11-0.286 4.672 0.213 1.56 0.734 3.063 1.53 4.423l11.947 20.692-62.446 36.043c-20.543-31.989-47.733-59.177-79.72-79.721l36.043-62.444 20.69 11.947c2.743 1.559 5.99 1.97 9.035 1.143s5.639-2.825 7.216-5.557c1.577-2.732 2.010-5.976 1.203-9.027-0.806-3.049-2.786-5.656-5.508-7.252l-62.123-35.84c-1.358-0.796-2.862-1.317-4.423-1.53-1.56-0.213-3.149-0.117-4.672 0.286-1.523 0.404-2.951 1.104-4.203 2.061s-2.301 2.152-3.089 3.516c-0.788 1.365-1.298 2.871-1.502 4.434-0.203 1.562-0.095 3.149 0.319 4.669 0.412 1.52 1.122 2.944 2.086 4.19 0.966 1.244 2.167 2.287 3.537 3.066l20.692 11.947-36.031 62.409c-33.731-17.559-70.892-27.533-108.882-29.221v-71.979h23.893c3.169 0 6.208-1.259 8.448-3.499 2.24-2.241 3.499-5.279 3.499-8.448s-1.259-6.208-3.499-8.448c-2.24-2.24-5.279-3.499-8.448-3.499h-71.68c-3.169 0-6.207 1.259-8.447 3.499-2.241 2.24-3.5 5.279-3.5 8.448s1.259 6.207 3.5 8.448c2.24 2.24 5.278 3.499 8.447 3.499h23.893v71.979c-38.009 1.697-75.189 11.686-108.929 29.269l-36.031-62.41 20.69-11.947c1.37-0.778 2.573-1.82 3.537-3.065 0.966-1.246 1.675-2.67 2.088-4.19s0.521-3.108 0.319-4.671c-0.203-1.562-0.714-3.069-1.502-4.433-0.788-1.365-1.838-2.56-3.089-3.517s-2.679-1.657-4.203-2.059c-1.523-0.402-3.112-0.501-4.672-0.287-1.562 0.213-3.065 0.734-4.425 1.53l-62.123 35.84c-1.37 0.779-2.571 1.822-3.537 3.066-0.964 1.246-1.674 2.67-2.086 4.19-0.414 1.52-0.522 3.108-0.319 4.669 0.203 1.563 0.714 3.069 1.502 4.434 0.788 1.364 1.838 2.559 3.089 3.516s2.679 1.657 4.203 2.061c1.523 0.402 3.112 0.499 4.672 0.286 1.562-0.213 3.065-0.734 4.423-1.53l20.692-11.947 36.043 62.446c-31.987 20.543-59.177 47.733-79.72 79.72l-62.397-36.043 11.947-20.69c1.559-2.743 1.97-5.99 1.143-9.035s-2.825-5.639-5.557-7.216c-2.731-1.577-5.976-2.010-9.027-1.203-3.049 0.806-5.656 2.786-7.252 5.508l-35.84 62.123c-0.796 1.358-1.317 2.862-1.53 4.423s-0.117 3.149 0.286 4.672c0.404 1.523 1.104 2.951 2.061 4.203s2.152 2.303 3.516 3.089c1.365 0.788 2.871 1.298 4.434 1.502 1.562 0.203 3.149 0.095 4.669-0.319 1.52-0.412 2.944-1.122 4.19-2.086 1.246-0.966 2.287-2.167 3.066-3.537l11.947-20.692 62.409 36.031c-17.576 33.727-27.566 70.889-29.269 108.882h-83.925v23.893h83.925c1.697 38.009 11.686 75.189 29.269 108.929l-62.409 36.031-11.947-20.69c-0.779-1.37-1.82-2.573-3.066-3.537-1.246-0.966-2.67-1.675-4.19-2.088s-3.108-0.521-4.669-0.319c-1.563 0.203-3.069 0.714-4.434 1.502-1.364 0.788-2.559 1.838-3.516 3.089s-1.657 2.679-2.061 4.203c-0.402 1.523-0.499 3.112-0.286 4.672 0.213 1.562 0.734 3.065 1.53 4.425l35.84 62.123c0.778 1.37 1.82 2.571 3.066 3.537 1.244 0.964 2.668 1.674 4.188 2.086 1.52 0.414 3.108 0.522 4.671 0.319 1.562-0.203 3.069-0.714 4.433-1.502 1.365-0.786 2.56-1.838 3.517-3.089s1.657-2.679 2.059-4.203c0.402-1.523 0.501-3.11 0.287-4.672s-0.734-3.065-1.53-4.423l-11.947-20.692 62.444-36.043c20.544 31.987 47.733 59.177 79.721 79.72l-36.043 62.446-20.692-11.947c-2.742-1.559-5.99-1.97-9.035-1.143-3.044 0.826-5.638 2.823-7.215 5.555s-2.011 5.978-1.205 9.027c0.806 3.051 2.786 5.658 5.508 7.253l62.123 35.84c1.36 0.796 2.863 1.317 4.423 1.53 1.562 0.213 3.149 0.115 4.672-0.287s2.953-1.102 4.204-2.059c1.252-0.957 2.301-2.152 3.089-3.517 0.788-1.364 1.297-2.87 1.5-4.433s0.095-3.149-0.317-4.671c-0.412-1.52-1.122-2.944-2.088-4.188-0.966-1.246-2.167-2.287-3.537-3.066l-20.692-11.947 36.032-62.41c33.729 17.56 70.892 27.534 108.881 29.222v71.979h-23.893c-3.169 0-6.207 1.259-8.447 3.499-2.241 2.24-3.5 5.279-3.5 8.448s1.259 6.207 3.5 8.448c2.24 2.24 5.278 3.499 8.447 3.499h71.68c3.169 0 6.208-1.259 8.448-3.499 2.24-2.241 3.499-5.279 3.499-8.448s-1.259-6.208-3.499-8.448c-2.24-2.24-5.279-3.499-8.448-3.499h-23.893v-71.979c38.010-1.697 75.189-11.686 108.929-29.269l36.032 62.409-20.692 11.947c-1.37 0.779-2.571 1.822-3.537 3.066-0.966 1.246-1.675 2.67-2.088 4.19s-0.521 3.108-0.317 4.669c0.203 1.563 0.713 3.069 1.5 4.434 0.788 1.364 1.838 2.559 3.089 3.516s2.681 1.658 4.204 2.061c1.523 0.402 3.11 0.499 4.672 0.286 1.56-0.213 3.063-0.732 4.423-1.53l62.123-35.84c2.722-1.596 4.702-4.203 5.508-7.252 0.806-3.051 0.373-6.295-1.205-9.027s-4.171-4.73-7.215-5.557c-3.045-0.826-6.293-0.415-9.035 1.143l-20.692 11.947-36.043-62.444c31.989-20.543 59.179-47.733 79.721-79.721l62.444 36.043-11.947 20.692c-0.796 1.36-1.317 2.863-1.53 4.423-0.213 1.562-0.115 3.149 0.287 4.672s1.102 2.953 2.059 4.204c0.957 1.252 2.153 2.301 3.517 3.089s2.871 1.297 4.433 1.5c1.563 0.203 3.15 0.095 4.671-0.317s2.944-1.122 4.19-2.088c1.244-0.966 2.287-2.167 3.065-3.537l35.84-62.123c1.56-2.742 1.971-5.99 1.145-9.035-0.828-3.044-2.825-5.638-5.557-7.215s-5.978-2.011-9.027-1.205c-3.051 0.806-5.658 2.786-7.253 5.508l-11.947 20.692-62.409-36.032c17.56-33.729 27.533-70.891 29.221-108.881h71.979v23.893c0 3.169 1.259 6.207 3.5 8.448 2.24 2.24 5.278 3.499 8.447 3.499s6.208-1.259 8.448-3.499c2.24-2.241 3.499-5.279 3.499-8.448v-71.68c0-3.169-1.259-6.208-3.499-8.448s-5.279-3.499-8.448-3.499zM512.009 750.945c-47.256 0-93.451-14.013-132.745-40.267-39.292-26.254-69.916-63.57-88.001-107.23-18.084-43.659-22.815-91.702-13.596-138.049 9.22-46.349 31.976-88.923 65.391-122.338 33.417-33.415 75.989-56.172 122.338-65.391s94.39-4.487 138.049 13.596c43.659 18.085 80.976 48.71 107.23 88.001s40.267 85.488 40.267 132.745c-0.073 63.346-25.269 124.078-70.062 168.87s-105.525 69.99-168.872 70.063z", "M512.007 476.167c-7.088 0-14.019 2.102-19.913 6.040s-10.487 9.535-13.2 16.084c-2.712 6.549-3.422 13.756-2.039 20.708s4.796 13.339 9.809 18.351c5.012 5.012 11.398 8.425 18.35 9.809 6.953 1.382 14.16 0.673 20.708-2.041 6.549-2.712 12.147-7.306 16.085-13.2s6.040-12.823 6.040-19.911c0-9.506-3.776-18.621-10.497-25.343s-15.838-10.497-25.343-10.497zM512.007 523.954c-2.364 0-4.673-0.701-6.638-2.014s-3.496-3.179-4.4-5.362c-0.905-2.183-1.141-4.585-0.68-6.902 0.461-2.318 1.599-4.446 3.27-6.117s3.8-2.809 6.117-3.27c2.317-0.461 4.719-0.225 6.902 0.68s4.049 2.436 5.362 4.4c1.313 1.964 2.014 4.274 2.014 6.638 0 3.169-1.259 6.207-3.5 8.447-2.24 2.241-5.278 3.5-8.447 3.5z", "M595.645 392.556c-7.088 0-14.017 2.102-19.911 6.040s-10.487 9.535-13.2 16.084c-2.714 6.549-3.423 13.756-2.041 20.708 1.384 6.952 4.797 13.338 9.809 18.351 5.013 5.012 11.399 8.425 18.351 9.808 6.952 1.384 14.158 0.674 20.708-2.039 6.549-2.712 12.146-7.306 16.084-13.2s6.040-12.823 6.040-19.911c0-9.506-3.776-18.623-10.497-25.343-6.721-6.721-15.836-10.497-25.343-10.497zM595.645 440.343c-2.362 0-4.672-0.701-6.636-2.014-1.966-1.313-3.496-3.179-4.4-5.362s-1.141-4.585-0.68-6.902c0.461-2.318 1.599-4.446 3.27-6.117 1.67-1.671 3.799-2.809 6.117-3.27 2.317-0.461 4.719-0.225 6.902 0.68s4.049 2.435 5.362 4.4c1.313 1.964 2.012 4.274 2.012 6.638 0 3.167-1.259 6.207-3.499 8.447-2.24 2.241-5.279 3.5-8.448 3.5z", "M428.396 392.556c-7.088 0-14.019 2.102-19.913 6.040s-10.487 9.535-13.2 16.084c-2.712 6.549-3.423 13.756-2.039 20.708 1.382 6.952 4.796 13.338 9.809 18.351 5.012 5.012 11.398 8.425 18.35 9.808 6.953 1.384 14.16 0.674 20.708-2.039 6.549-2.712 12.147-7.306 16.085-13.2s6.040-12.823 6.040-19.911c0-9.506-3.776-18.623-10.497-25.343-6.721-6.721-15.838-10.497-25.343-10.497zM428.396 440.343c-2.364 0-4.673-0.701-6.638-2.014-1.966-1.313-3.496-3.179-4.4-5.362s-1.141-4.585-0.68-6.902c0.461-2.318 1.599-4.446 3.27-6.117s3.799-2.809 6.117-3.27c2.317-0.461 4.719-0.225 6.902 0.68s4.049 2.435 5.362 4.4c1.313 1.964 2.014 4.274 2.014 6.638 0 3.167-1.259 6.207-3.5 8.447-2.24 2.241-5.279 3.5-8.447 3.5z", "M595.645 559.778c-7.088 0-14.017 2.102-19.911 6.040s-10.487 9.535-13.2 16.084c-2.714 6.549-3.423 13.756-2.041 20.708 1.384 6.952 4.797 13.339 9.809 18.351 5.013 5.012 11.399 8.425 18.351 9.809 6.952 1.382 14.158 0.673 20.708-2.039 6.549-2.714 12.146-7.307 16.084-13.201s6.040-12.823 6.040-19.911c0-9.506-3.776-18.621-10.497-25.343s-15.836-10.497-25.343-10.497zM595.645 607.565c-2.362 0-4.672-0.701-6.636-2.014-1.966-1.313-3.496-3.179-4.4-5.362s-1.141-4.585-0.68-6.902c0.461-2.317 1.599-4.446 3.27-6.117 1.67-1.671 3.799-2.809 6.117-3.27 2.317-0.461 4.719-0.225 6.902 0.68s4.049 2.436 5.362 4.4c1.313 1.964 2.012 4.274 2.012 6.638 0 3.169-1.259 6.207-3.499 8.447-2.24 2.241-5.279 3.5-8.448 3.5z", "M428.396 559.778c-7.088 0-14.019 2.102-19.913 6.040s-10.487 9.535-13.2 16.084c-2.712 6.549-3.423 13.756-2.039 20.708 1.382 6.952 4.796 13.339 9.809 18.351 5.012 5.012 11.398 8.425 18.35 9.809 6.953 1.382 14.16 0.673 20.708-2.039 6.549-2.714 12.147-7.307 16.085-13.201s6.040-12.823 6.040-19.911c0-9.506-3.776-18.621-10.497-25.343s-15.838-10.497-25.343-10.497zM428.396 607.565c-2.364 0-4.673-0.701-6.638-2.014-1.966-1.313-3.496-3.179-4.4-5.362s-1.141-4.585-0.68-6.902c0.461-2.317 1.599-4.446 3.27-6.117s3.799-2.809 6.117-3.27c2.317-0.461 4.719-0.225 6.902 0.68s4.049 2.436 5.362 4.4c1.313 1.964 2.014 4.274 2.014 6.638 0 3.169-1.259 6.207-3.5 8.447-2.24 2.241-5.279 3.5-8.447 3.5z", "M512.013 297c-42.532 0-84.107 12.612-119.471 36.241-35.362 23.629-62.925 57.213-79.201 96.506-16.276 39.295-20.534 82.532-12.237 124.245s28.777 80.030 58.852 110.104c30.074 30.073 68.39 50.554 110.104 58.852s84.951 4.039 124.244-12.237c39.295-16.276 72.879-43.839 96.508-79.202 23.629-35.362 36.241-76.938 36.241-119.47-0.067-57.011-22.744-111.669-63.057-151.983-40.314-40.313-94.972-62.99-151.983-63.057zM512.013 703.186c-37.806 0-74.762-11.21-106.196-32.213s-55.933-50.857-70.401-85.784c-14.467-34.928-18.253-73.361-10.877-110.44s25.58-71.138 52.314-97.87c26.732-26.732 60.79-44.938 97.87-52.312 37.079-7.376 75.511-3.591 110.438 10.877 34.928 14.467 64.781 38.967 85.784 70.4 21.003 31.434 32.215 68.39 32.215 106.196-0.061 50.677-20.218 99.261-56.053 135.095-35.834 35.833-84.417 55.991-135.094 56.051z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["picto-virus"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 29,
      id: 25,
      name: "virus",
      prevSize: 32,
      code: 59675
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 4
  }, {
    icon: {
      paths: ["M695.164 554.671h-524.497v-85.333h524.497l-225.83-225.831 60.339-60.34 328.836 328.838-328.836 328.836-60.339-60.339 225.83-225.83z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["linkArrow"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 38,
      id: 24,
      name: "linkArrow",
      prevSize: 32,
      code: 59648
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 5
  }, {
    icon: {
      paths: ["M471.923 692.582v-524.499h85.333v524.495l225.826-225.826 60.343 60.339-328.836 328.836-328.838-328.836 60.34-60.339 225.832 225.83z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["linkArrowDown"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 40,
      id: 23,
      name: "linkArrowDown",
      prevSize: 32,
      code: 59649
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 6
  }, {
    icon: {
      paths: ["M279.017 349.833v543.794h-182.912v-543.794h182.912z", "M291.093 181.638c0 52.214-39.721 93.994-103.5 93.994h-1.169c-61.408 0-101.107-41.78-101.107-93.994 0-53.319 40.908-93.929 103.482-93.929s101.107 40.611 102.294 93.929z", "M938.667 581.85l-0.009 311.795h-182.903v-290.927c0-73.075-26.47-122.94-92.685-122.94-50.534 0-80.631 33.613-93.85 66.082-4.838 11.635-6.025 27.849-6.025 44.1v303.701h-182.935c0 0 2.411-492.768 0-543.795h182.935v77.026c24.277-37.029 67.755-89.809 164.868-89.809 120.367 0 210.603 77.738 210.603 244.766z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["linkedin"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 43,
      id: 22,
      name: "linkedin",
      prevSize: 32,
      code: 59650
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 7
  }, {
    icon: {
      paths: ["M706.022 255.923l-172.689-0.006v-85.333l319.996 0.009v320.049h-85.333v-176.012l-256.99 256.989-60.339-60.339 255.356-255.356z", "M170.667 170.667h213.333v85.333h-128v512h512v-128h85.333v213.333h-682.667v-682.667z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["linkExternal"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 44,
      id: 21,
      name: "linkExternal",
      prevSize: 32,
      code: 59651
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 8
  }, {
    icon: {
      paths: ["M85.333 170.667h853.333v85.333h-853.333v-85.333z", "M341.333 469.333h597.333v85.333h-597.333v-85.333z", "M85.333 768h853.333v85.333h-853.333v-85.333z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["menu"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 46,
      id: 20,
      name: "menu",
      prevSize: 32,
      code: 59652
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 9
  }, {
    icon: {
      paths: ["M810.667 512l-554.667 384v-768l554.667 384zM660.753 512l-319.42-221.135v442.272l319.42-221.137z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["play"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 48,
      id: 19,
      name: "play",
      prevSize: 32,
      code: 59653
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 10
  }, {
    icon: {
      paths: ["M865.958 938.667l-293.666-293.7c-130.641 92.873-310.653 70.157-414.121-52.258s-95.87-303.686 17.478-417.013c113.318-113.377 294.618-121.007 417.063-17.551 122.441 103.456 145.173 283.477 52.288 414.118l293.666 293.7-72.708 72.704zM393.625 188.129c-97.441-0.022-181.508 68.374-201.302 163.778-19.794 95.402 30.124 191.594 119.532 230.336s193.733 9.382 249.814-70.302c56.077-79.68 48.495-187.786-18.155-258.864l31.091 30.829-35.661-35.556c-38.451-38.682-90.778-60.367-145.319-60.221z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["search"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 51,
      id: 18,
      name: "search",
      prevSize: 32,
      code: 59654
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 11
  }, {
    icon: {
      paths: ["M752.465 895.991c-43.601 0.478-84.928-18.449-111.689-51.153-26.761-32.708-35.874-75.426-24.631-115.447l-252.244-136.973c-43.587 37.939-107.479 45.969-159.951 20.1-52.471-25.865-82.347-80.119-74.792-135.817 7.555-55.703 50.931-100.987 108.591-113.371s117.321 10.772 149.361 57.968l228.995-124.377c-2.965-10.635-4.535-21.577-4.676-32.578-0.576-64.056 46.251-119.701 112.149-133.265s132.77 18.679 160.149 77.218c27.379 58.539 7.748 127.298-47.010 164.672-54.763 37.373-129.617 33.098-179.273-10.24l-247.851 134.56c-0.246 9.929-1.706 19.793-4.352 29.402l252.203 136.93c46.43-40.478 115.516-46.729 169.156-15.3 53.636 31.433 78.763 92.89 61.525 150.477s-72.649 97.284-135.663 97.195zM752.465 704.585c-33.382 0-60.446 25.707-60.446 57.421s27.063 57.421 60.446 57.421c33.378 0 60.442-25.707 60.442-57.421s-27.063-57.421-60.442-57.421zM268.927 436.612c-33.381 0-60.442 25.707-60.442 57.421s27.061 57.425 60.442 57.425c33.382 0 60.442-25.711 60.442-57.425s-27.060-57.421-60.442-57.421zM752.465 206.922c-33.382 0-60.446 25.709-60.446 57.422s27.063 57.423 60.446 57.423c33.378 0 60.442-25.709 60.442-57.423s-27.063-57.422-60.442-57.422z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["share"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 53,
      id: 17,
      name: "share",
      prevSize: 32,
      code: 59655
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 12
  }, {
    icon: {
      paths: ["M520.205 128h-0.038c-0.734 0-1.429 0-2.086 0.009-5.257 0.051-13.892 0.131-14.669 0.14-18.944 0-56.845 2.561-97.559 19.763-23.278 9.829-44.216 23.118-62.23 39.5-21.478 19.52-38.975 43.586-51.996 71.54-19.069 40.931-14.543 109.874-10.907 165.278l0.013 0.087c0.389 5.935 0.798 12.13 1.172 18.167-2.798 1.229-7.333 2.526-14.019 2.526-10.756 0-23.548-3.29-38.008-9.775-4.255-1.899-9.111-2.859-14.47-2.859-8.609 0-17.685 2.428-25.558 6.857-9.905 5.568-16.305 13.436-18.043 22.161-1.146 5.769-1.090 17.173 12.145 28.74 7.28 6.37 17.975 12.241 31.779 17.463 3.622 1.365 7.921 2.667 12.475 4.049 15.801 4.809 39.715 12.070 45.952 26.121 3.16 7.125 1.8 16.499-4.031 27.827-0.153 0.307-0.305 0.61-0.445 0.93-1.457 3.255-15.054 32.734-42.942 63.825-15.847 17.681-33.302 32.457-51.852 43.93-22.641 14.007-47.139 23.164-72.808 27.209-10.080 1.587-17.278 10.18-16.716 19.951 0.172 2.816 0.862 5.623 2.059 8.337l0.029 0.051c4.076 9.122 13.525 16.875 28.888 23.714 18.773 8.346 46.85 15.369 83.442 20.86 1.849 3.366 3.768 11.827 5.097 17.617 1.391 6.157 2.842 12.484 4.91 19.209 2.231 7.283 8.019 15.987 22.886 15.987 5.635 0 12.114-1.216 19.618-2.607 10.989-2.065 26.016-4.881 44.771-4.881 10.398 0 21.175 0.879 32.022 2.603 20.909 3.332 38.935 15.522 59.791 29.636 30.527 20.655 65.083 44.036 117.874 44.036 1.442 0 2.884-0.043 4.309-0.141 1.745 0.081 3.908 0.141 6.191 0.141 52.809 0 87.356-23.39 117.85-44.028l0.047-0.043c20.86-14.097 38.865-26.27 59.772-29.602 10.842-1.724 21.615-2.603 32.017-2.603 17.92 0 32.102 2.189 44.77 4.553 8.269 1.557 14.69 2.308 19.622 2.308l0.482 0.009h0.499c10.871 0 18.863-5.713 21.914-15.71 2.027-6.583 3.473-12.766 4.898-19.025 1.242-5.427 3.23-14.127 5.077-17.527 36.617-5.504 64.683-12.51 83.456-20.855 15.33-6.805 24.768-14.549 28.868-23.637 1.229-2.722 1.95-5.547 2.108-8.422 0.58-9.754-6.63-18.364-16.717-19.947-114.078-18.001-165.47-130.202-167.595-134.967-0.137-0.311-0.294-0.623-0.452-0.926-5.833-11.332-7.181-20.698-4.019-27.831 6.225-14.037 30.123-21.299 45.935-26.108 4.578-1.378 8.892-2.692 12.489-4.049 15.565-5.884 26.692-12.271 34.031-19.52 8.764-8.644 10.475-16.926 10.368-22.345-0.269-13.111-10.739-24.759-27.396-30.468-5.628-2.223-12.041-3.401-18.573-3.401-4.45 0-11.034 0.585-17.267 3.371-13.346 5.978-25.301 9.246-35.567 9.711-5.457-0.265-9.284-1.395-11.763-2.479 0.311-5.111 0.657-10.368 1.011-15.845l0.149-2.345c3.657-55.44 8.196-124.436-10.88-165.396-13.077-28.054-30.635-52.182-52.198-71.744-18.086-16.393-39.095-29.68-62.46-39.502-40.653-17.074-78.554-19.625-97.523-19.625z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["snapchat"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 55,
      id: 16,
      name: "snapchat",
      prevSize: 32,
      code: 59656
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 13
  }, {
    icon: {
      paths: ["M907.878 197.402l-566.304 702.221-225.262-275.319 66.045-54.037 158.739 194.014 500.359-620.446 66.423 53.568z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["tick"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 56,
      id: 15,
      name: "tick",
      prevSize: 32,
      code: 59657
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 14
  }, {
    icon: {
      paths: ["M672.593 128h-134.69v523.127c0 62.336-51.806 113.536-116.273 113.536-64.468 0-116.272-51.2-116.272-113.536 0-61.214 50.653-111.3 112.819-113.527v-131.339c-136.995 2.225-247.511 110.193-247.511 244.866 0 135.795 112.818 244.873 252.115 244.873s252.115-110.191 252.115-244.873v-268.241c50.654 35.618 112.815 56.764 178.436 57.882v-131.342c-101.303-3.339-180.74-83.478-180.74-181.426z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["tiktok"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 33,
      id: 14,
      name: "tiktok",
      prevSize: 32,
      code: 59658
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 15
  }, {
    icon: {
      paths: ["M499.674 352.267l1.852 29.527-30.831-3.616c-112.216-13.86-210.252-60.862-293.491-139.803l-40.694-39.169-10.482 28.925c-22.197 64.478-8.015 132.571 38.228 178.368 24.663 25.308 19.114 28.926-23.43 13.86-14.798-4.821-27.746-8.436-28.979-6.629-4.316 4.218 10.482 59.054 22.197 80.75 16.031 30.127 48.71 59.657 84.471 77.133l30.212 13.858-35.761 0.602c-34.528 0-35.762 0.602-32.062 13.257 12.332 39.172 61.041 80.751 115.301 98.829l38.228 12.655-33.295 19.281c-49.327 27.721-107.285 43.388-165.244 44.591-27.746 0.606-50.56 3.012-50.56 4.821 0 6.029 75.223 39.774 119 53.030 131.332 39.168 287.328 22.293 404.477-44.595 83.238-47.603 166.477-142.212 205.321-233.805 20.962-48.811 41.929-137.996 41.929-180.78 0-27.72 1.847-31.335 36.378-64.478 20.348-19.283 39.462-40.374 43.162-46.4 6.165-11.45 5.547-11.45-25.899-1.205-52.407 18.078-59.806 15.668-33.911-11.449 19.115-19.283 41.929-54.234 41.929-64.478 0-1.808-9.25 1.205-19.729 6.628-11.102 6.026-35.763 15.065-54.259 20.489l-33.297 10.244-30.212-19.886c-16.649-10.847-40.077-22.898-52.412-26.514-31.445-8.436-79.535-7.231-107.9 2.41-77.073 27.117-125.781 97.018-120.235 173.548z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["twitter"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 35,
      id: 13,
      name: "twitter",
      prevSize: 32,
      code: 59659
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 16
  }, {
    icon: {
      paths: ["M828.719 231.804c34.88 10.163 62.349 40.108 71.671 78.136 16.943 68.922 16.943 212.727 16.943 212.727s0 143.799-16.943 212.727c-9.323 38.029-36.791 67.972-71.671 78.14-63.215 18.466-316.719 18.466-316.719 18.466s-253.504 0-316.722-18.466c-34.882-10.167-62.352-40.111-71.675-78.14-16.937-68.928-16.937-212.727-16.937-212.727s0-143.805 16.937-212.727c9.323-38.028 36.793-67.974 71.675-78.136 63.218-18.47 316.722-18.47 316.722-18.47s253.504 0 316.719 18.47zM436.002 401.621v268.984l202.667-134.485-202.667-134.499z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["youtube"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 36,
      id: 12,
      name: "youtube",
      prevSize: 32,
      code: 59660
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 17
  }, {
    icon: {
      paths: ["M170.667 469.333h682.667v85.333h-682.667v-85.333z", "M554.667 170.667l0 682.667h-85.333v-682.667h85.333z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["add"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 37,
      id: 11,
      name: "add",
      prevSize: 32,
      code: 59661
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 18
  }, {
    icon: {
      paths: ["M511.996 175.335l-373.663 709.96h747.325l-373.662-709.96zM476.126 106.072c15.198-28.873 56.542-28.874 71.74 0l412.531 783.81c14.208 26.991-5.367 59.413-35.87 59.413h-825.063c-30.502 0-50.075-32.418-35.869-59.413l412.531-783.81z", "M469.333 661.333v-277.333h85.333v277.333h-85.333z", "M469.333 821.333h85.333v-85.333h-85.333v85.333z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["alert"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 39,
      id: 10,
      name: "alert",
      prevSize: 32,
      code: 59662
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 19
  }, {
    icon: {
      paths: ["M938.667 307.846l-426.667 481.487-426.667-481.487 71.103-73.18 355.564 408.41 355.563-408.41 71.104 73.18z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["arrowDown"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 41,
      id: 9,
      name: "arrowDown",
      prevSize: 32,
      code: 59663
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 20
  }, {
    icon: {
      paths: ["M694.818 938.667l-438.818-426.667 438.818-426.667 73.182 71.103-365.744 355.564 365.744 355.563-73.182 71.104z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["arrowLeft"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 42,
      id: 8,
      name: "arrowLeft",
      prevSize: 32,
      code: 59664
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 21
  }, {
    icon: {
      paths: ["M329.18 938.667l438.82-426.667-438.82-426.667-73.18 71.103 365.743 355.564-365.743 355.563 73.18 71.104z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["arrowRight"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 45,
      id: 7,
      name: "arrowRight",
      prevSize: 32,
      code: 59665
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 22
  }, {
    icon: {
      paths: ["M938.667 716.151l-426.667-481.485-426.667 481.485 71.103 73.182 355.564-408.41 355.563 408.41 71.104-73.182z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["arrowUp"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 47,
      id: 6,
      name: "arrowUp",
      prevSize: 32,
      code: 59666
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 23
  }, {
    icon: {
      paths: ["M134.948 197.833l69.186-69.818 691.863 698.182-69.186 69.818-691.863-698.182z", "M128 826.167l69.186 69.818 691.863-698.182-69.186-69.818-691.863 698.182z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["close"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 49,
      id: 5,
      name: "close",
      prevSize: 32,
      code: 59667
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 24
  }, {
    icon: {
      paths: ["M736.644 546.999l-181.999 197.167v-637.5h-85.333v637.461l-181.963-197.129-62.703 57.882 229.34 248.452h-219.34v85.333h554.666v-85.333h-219.307l229.342-248.452-62.703-57.882z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["download"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 50,
      id: 4,
      name: "download",
      prevSize: 32,
      code: 59668
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 25
  }, {
    icon: {
      paths: ["M582.383 938.667v-448.051h126.221l16.73-154.403h-142.95l0.213-77.28c0-40.27 3.904-61.848 62.933-61.848h78.912v-154.419h-126.242c-151.637 0-205.012 74.901-205.012 200.862v92.702h-94.521v154.402h94.521v448.034h189.196z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["facebook"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 54,
      id: 2,
      name: "facebook",
      prevSize: 32,
      code: 59670
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 27
  }, {
    icon: {
      paths: ["M170.667 469.333h682.667v85.333h-682.667v-85.333z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["hide"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 57,
      id: 1,
      name: "hide",
      prevSize: 32,
      code: 59671
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 28
  }, {
    icon: {
      paths: ["M512.077 196.926c102.699 0 114.863 0.451 155.251 2.252 37.538 1.652 57.805 7.958 71.322 13.213 17.865 6.907 30.78 15.315 44.143 28.678 13.513 13.513 21.769 26.276 28.676 44.143 5.257 13.513 11.563 33.933 13.214 71.32 1.801 40.54 2.253 52.702 2.253 155.254 0 102.699-0.452 114.863-2.253 155.251-1.651 37.538-7.957 57.805-13.214 71.322-6.908 17.865-15.313 30.78-28.676 44.143-13.517 13.513-26.278 21.769-44.143 28.676-13.517 5.257-33.937 11.563-71.322 13.214-40.542 1.801-52.702 2.253-155.251 2.253-102.703 0-114.864-0.452-155.254-2.253-37.537-1.651-57.807-7.957-71.32-13.214-17.868-6.908-30.78-15.313-44.143-28.676-13.513-13.513-21.771-26.278-28.678-44.143-5.255-13.517-11.561-33.937-13.213-71.322-1.802-40.542-2.252-52.702-2.252-155.251 0-102.702 0.451-114.864 2.252-155.254 1.652-37.537 7.958-57.807 13.213-71.32 6.907-17.868 15.315-30.78 28.678-44.143 13.513-13.513 26.276-21.772 44.143-28.678 13.513-5.255 33.933-11.561 71.32-13.213 40.39-1.802 52.551-2.252 155.254-2.252zM512.077 127.708c-104.354 0-117.417 0.451-158.407 2.252-40.84 1.802-68.917 8.408-93.241 17.868-25.375 9.91-46.846 22.973-68.167 44.444-21.471 21.321-34.534 42.792-44.443 68.017-9.46 24.474-16.066 52.401-17.868 93.242-1.802 41.14-2.252 54.203-2.252 158.555 0 104.354 0.451 117.414 2.252 158.404 1.802 40.841 8.408 68.919 17.868 93.244 9.91 25.374 22.973 46.844 44.443 68.164 21.321 21.325 42.792 34.534 68.017 44.297 24.474 9.459 52.401 16.064 93.241 17.865 40.99 1.805 54.053 2.253 158.404 2.253 104.354 0 117.419-0.448 158.409-2.253 40.841-1.801 68.915-8.405 93.239-17.865 25.225-9.762 46.699-22.972 68.019-44.297 21.321-21.321 34.534-42.79 44.292-68.015 9.459-24.474 16.064-52.403 17.869-93.239 1.801-40.994 2.249-54.054 2.249-158.409 0-104.351-0.448-117.414-2.249-158.404-1.805-40.84-8.41-68.918-17.869-93.242-9.459-25.525-22.524-46.996-43.994-68.317-21.321-21.321-42.79-34.534-68.015-44.294-24.478-9.459-52.403-16.066-93.244-17.868-41.139-1.952-54.204-2.403-158.554-2.403z", "M512.085 314.625c-109.008 0-197.445 88.437-197.445 197.443 0 109.009 88.437 197.444 197.445 197.444 109.005 0 197.444-88.435 197.444-197.444 0-109.007-88.439-197.443-197.444-197.443zM512.085 640.145c-70.72 0-128.077-57.357-128.077-128.077s57.357-128.075 128.077-128.075c70.72 0 128.077 57.355 128.077 128.075s-57.357 128.077-128.077 128.077z", "M763.477 306.863c0 25.535-20.727 46.113-46.114 46.113-25.536 0-46.114-20.728-46.114-46.113 0-25.535 20.727-46.113 46.114-46.113s46.114 20.728 46.114 46.113z"],
      attrs: [],
      isMulticolor: !1,
      isMulticolor2: !1,
      grid: 0,
      tags: ["instagram"],
      colorPermutations: {}
    },
    attrs: [],
    properties: {
      order: 34,
      id: 0,
      name: "instagram",
      prevSize: 32,
      code: 59672
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 29
  }],
  height: 1024,
  metadata: {
    name: "icomoon"
  },
  preferences: {
    showGlyphs: !0,
    showQuickUse: !0,
    showQuickUse2: !0,
    showSVGs: !0,
    fontPref: {
      prefix: "icon-",
      metadata: {
        fontFamily: "icomoon",
        majorVersion: 1,
        minorVersion: 0
      },
      metrics: {
        emSize: 1024,
        baseline: 6.25,
        whitespace: 50
      },
      embed: !1,
      showMetadata: !1
    },
    imagePref: {
      prefix: "icon-",
      png: !0,
      useClassSelector: !0,
      color: 0,
      bgColor: 16777215,
      classSelector: ".icon"
    },
    historySize: 50,
    showCodes: !0,
    gridSize: 16
  }
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var f = c(function (s, t) {
  var c = s.className,
      r = s.icon,
      i = s.color,
      _s$size = s.size,
      o = _s$size === void 0 ? 24 : _s$size,
      _s$customIcons = s.customIcons,
      l = _s$customIcons === void 0 ? [] : _s$customIcons,
      n = function (e, s) {
    var t = {};

    for (var c in e) {
      Object.prototype.hasOwnProperty.call(e, c) && s.indexOf(c) < 0 && (t[c] = e[c]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var r = 0;

      for (c = Object.getOwnPropertySymbols(e); r < c.length; r++) {
        s.indexOf(c[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, c[r]) && (t[c[r]] = e[c[r]]);
      }
    }

    return t;
  }(s, ["className", "icon", "color", "size", "customIcons"]);

  return e(h, Object.assign({
    ref: t,
    iconSet: Object.assign(Object.assign({}, v), {
      icons: [].concat(_toConsumableArray(v.icons), _toConsumableArray(l))
    }),
    icon: r,
    className: a("cds-icon", c),
    color: i,
    size: o
  }, n));
}),
    M = c(function (t, c) {
  var _t$variant = t.variant,
      r = _t$variant === void 0 ? "primary" : _t$variant,
      _t$size = t.size,
      i = _t$size === void 0 ? "small" : _t$size,
      o = t.children,
      l = t.className,
      n = t.iconPrefix,
      d = t.iconSuffix,
      p = t.href,
      m = function (e, s) {
    var t = {};

    for (var c in e) {
      Object.prototype.hasOwnProperty.call(e, c) && s.indexOf(c) < 0 && (t[c] = e[c]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var r = 0;

      for (c = Object.getOwnPropertySymbols(e); r < c.length; r++) {
        s.indexOf(c[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, c[r]) && (t[c[r]] = e[c[r]]);
      }
    }

    return t;
  }(t, ["variant", "size", "children", "className", "iconPrefix", "iconSuffix", "href"]);

  var g = (null == n ? void 0 : n.component) || f,
      u = (null == d ? void 0 : d.component) || f;
  return s("a", Object.assign({
    ref: c,
    href: p,
    className: a("cds-link", l, "cds-link--".concat(r), "cds-link--".concat(r, "-").concat(i))
  }, m, {
    children: [(null == n ? void 0 : n.props) && e(g, Object.assign({
      className: a("icon__prefix", "icon--".concat(r, "-icon"))
    }, n.props)), e("span", Object.assign({
      className: a("cds-link__inner", {
        "cds-sr-only": r.includes("-icon")
      })
    }, {
      children: o
    })), (null == d ? void 0 : d.props) && e(u, Object.assign({
      className: a("icon__suffix", "icon--".concat(r, "-icon"))
    }, d.props))]
  }));
}),
    z = c(function (s, t) {
  var _a;

  var c = s.content,
      _s$tag = s.tag,
      r = _s$tag === void 0 ? "div" : _s$tag,
      i = s.variant,
      o = s.align,
      l = s.className,
      _s$wrapping = s.wrapping,
      n = _s$wrapping === void 0 ? "break-word" : _s$wrapping,
      d = s.link,
      p = function (e, s) {
    var t = {};

    for (var c in e) {
      Object.prototype.hasOwnProperty.call(e, c) && s.indexOf(c) < 0 && (t[c] = e[c]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var r = 0;

      for (c = Object.getOwnPropertySymbols(e); r < c.length; r++) {
        s.indexOf(c[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, c[r]) && (t[c[r]] = e[c[r]]);
      }
    }

    return t;
  }(s, ["content", "tag", "variant", "align", "className", "wrapping", "link"]);

  var m = (null == d ? void 0 : d.component) || M,
      g = a("cds-typography", l, (_a = {}, _defineProperty(_a, "cds-typography--align-".concat(u = o), u), _defineProperty(_a, "cds-typography--variant-".concat(h = i), h), _defineProperty(_a, "cds-typography--wrapping-".concat(v = n), v), _a));
  var u, h, v;

  var f = r && "rte" !== i ? r : "div",
      z = function (e, s, t) {
    return "rte" !== s && "div" !== e ? t.replace(/^<\/?[^>]+(>|$)/g, "").replace(/<\/[^>]+(>$)/g, "") : t;
  }(r, i, c);

  return e(f, d ? Object.assign({
    className: g,
    ref: t
  }, p, {
    children: e(m, Object.assign({}, d.props, {
      iconPrefix: void 0,
      iconSuffix: void 0
    }, {
      children: e("span", {
        dangerouslySetInnerHTML: {
          __html: z
        }
      })
    }))
  }) : Object.assign({
    className: g,
    ref: t,
    dangerouslySetInnerHTML: {
      __html: z
    }
  }, p));
}),
    b = function b(_ref) {
  var s = _ref.props,
      _ref$component = _ref.component,
      t = _ref$component === void 0 ? l : _ref$component,
      c = _ref.className;
  return e(t, Object.assign({
    className: c
  }, s));
},
    I = function I(_ref2) {
  var s = _ref2.props,
      _ref2$component = _ref2.component,
      t = _ref2$component === void 0 ? n : _ref2$component,
      c = _ref2.className;
  return e(t, Object.assign({
    className: c
  }, s));
},
    x = c(function (t, c) {
  var _a2;

  var l = t.className,
      n = t.variant,
      p = t.tag,
      m = t.mode,
      g = t.disclaimer,
      u = t.backgroundImage,
      h = t.foregroundImage,
      v = t.headingBlock,
      f = t.ctaBlock,
      _t$size2 = t.size,
      M = _t$size2 === void 0 ? "hero" : _t$size2,
      _t$width = t.width,
      x = _t$width === void 0 ? "full-screen" : _t$width,
      O = d(t, ["className", "variant", "tag", "mode", "disclaimer", "backgroundImage", "foregroundImage", "headingBlock", "ctaBlock", "size", "width"]);
  return s(o, Object.assign({
    ref: c,
    className: a("cds-teaser-full-image", l, "cds-teaser-full-image--".concat(M, "-size"), "cds-teaser-full-image--".concat(x, "-width"), "cds-teaser-full-image--".concat(M, "-").concat(x), (_a2 = {}, _defineProperty(_a2, "cds-teaser-full-image--".concat(n, "-variant"), n), _defineProperty(_a2, "cds-teaser-full-image--has-image", h), _a2)),
    element: p
  }, O, {
    children: [e(r, Object.assign({
      maxWidth: "max-text",
      className: "cds-teaser-full-image__container"
    }, {
      children: s(o, Object.assign({
        mode: m,
        removeAllSpacing: !0,
        className: a("cds-teaser-full-image__section")
      }, {
        children: [s("div", Object.assign({
          className: "cds-teaser-full-image__text"
        }, {
          children: [s("div", Object.assign({
            className: "cds-teaser-full-image__text-content"
          }, {
            children: [v && e(I, Object.assign({
              className: "cds-teaser-full-image__heading"
            }, v)), f && e(b, Object.assign({
              className: "cds-teaser-full-image__cta"
            }, f))]
          })), g && e(z, {
            className: "cds-teaser-full-image__disclaimer",
            variant: "bodyS",
            content: g
          })]
        })), h && e("div", Object.assign({
          className: "cds-teaser-full-image__fg"
        }, {
          children: e(i, Object.assign({}, h, {
            className: "cds-teaser-full-image__fg-img"
          }))
        }))]
      }))
    })), u && e("div", Object.assign({
      className: "cds-teaser-full-image__bg"
    }, {
      children: e(i, Object.assign({
        className: "cds-teaser-full-image__bg-img"
      }, u))
    }))]
  }));
}),
    O = c(function (t, c) {
  var r = t.className,
      l = t.tag,
      n = t.mode,
      p = t.backgroundImage,
      m = t.foregroundImage,
      g = t.headingBlock,
      u = t.disclaimer,
      h = t.ctaBlock,
      v = t.variant,
      _t$size3 = t.size,
      f = _t$size3 === void 0 ? "hero" : _t$size3,
      _t$width2 = t.width,
      M = _t$width2 === void 0 ? "full-screen" : _t$width2,
      x = d(t, ["className", "tag", "mode", "backgroundImage", "foregroundImage", "headingBlock", "disclaimer", "ctaBlock", "variant", "size", "width"]);
  return s(o, Object.assign({
    ref: c,
    className: a("cds-teaser-split", r, "cds-teaser-split--".concat(f, "-size"), "cds-teaser-split--".concat(M, "-width"), "cds-teaser-split--".concat(f, "-").concat(M), _defineProperty({}, "cds-teaser-split--".concat(v, "-variant"), v)),
    removeAllSpacing: !0,
    mode: n,
    element: l
  }, x, {
    children: [s("div", Object.assign({
      className: "cds-teaser-split__text"
    }, {
      children: [s("div", Object.assign({
        className: "cds-teaser-split__text-content"
      }, {
        children: [g && e(I, Object.assign({
          className: "cds-teaser-split__heading"
        }, g)), h && e(b, Object.assign({
          className: "cds-teaser-split__cta"
        }, h))]
      })), u && e(z, {
        className: "cds-teaser-split__disclaimer",
        variant: "bodyS",
        content: u
      })]
    })), s("div", Object.assign({
      className: "cds-teaser-split__image"
    }, {
      children: [p && e(i, Object.assign({
        className: "cds-teaser-split__bg-img"
      }, p)), m && e("div", Object.assign({
        className: "cds-teaser-split__image-overlay"
      }, {
        children: e(i, Object.assign({}, m, {
          className: "cds-teaser-split__fg-img"
        }))
      }))]
    }))]
  }));
}),
    y = function y(e, s, t, c, r) {
  var _a4;

  return a(e, c, (_a4 = {}, _defineProperty(_a4, "cds-strip--".concat(s, "-variant"), s), _defineProperty(_a4, "cds-strip--".concat(t, "-width"), t), _defineProperty(_a4, "cds-strip--has-image", r), _a4));
},
    _ = function _(e) {
  return "strip-center" === e ? "center" : "start";
},
    j = function j(e, s) {
  var t = Object.assign(Object.assign({}, e.props), {
    align: _(s)
  });
  return Object.assign(Object.assign({}, e), {
    props: t
  });
},
    w = c(function (t, c) {
  var a,
      l = t.className,
      n = t.variant,
      p = t.tag,
      m = t.mode,
      _t$width3 = t.width,
      g = _t$width3 === void 0 ? "full-screen" : _t$width3,
      u = t.foregroundImage,
      h = t.headingBlock,
      v = t.disclaimer,
      f = t.ctaBlock,
      M = d(t, ["className", "variant", "tag", "mode", "width", "foregroundImage", "headingBlock", "disclaimer", "ctaBlock"]);
  return e(o, Object.assign({
    ref: c,
    className: y("cds-strip", n, g, l, u),
    mode: m,
    element: p
  }, M, {
    children: s(r, Object.assign({
      className: "cds-strip__container",
      maxWidth: (a = u, a ? "max-grid" : "max-text")
    }, {
      children: [s("div", Object.assign({
        className: "cds-strip__text"
      }, {
        children: [h && e(I, Object.assign({
          className: "cds-strip__heading"
        }, j(h, n))), f && e(b, Object.assign({
          className: "cds-strip__cta"
        }, j(f, n))), v && e(z, {
          className: "cds-strip__disclaimer",
          variant: "bodyXS",
          content: v,
          align: _(n)
        })]
      })), u && e("div", Object.assign({
        className: "cds-strip__image"
      }, {
        children: e(i, Object.assign({
          className: "cds-strip__image-img"
        }, u))
      }))]
    }))
  }));
}),
    N = c(function (s, t) {
  var c = s.variant,
      r = d(s, ["variant"]);

  switch (c) {
    case "split-start":
    case "split-end":
      return e(O, Object.assign({
        ref: t,
        variant: c
      }, r));

    case "strip-start":
    case "strip-center":
      return e(w, Object.assign({
        ref: t,
        variant: c
      }, r));

    case "full-image":
      return e(x, Object.assign({
        ref: t,
        variant: c
      }, r));

    default:
      return null;
  }
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


export { N as Teaser };